import { Button, HFlow, Icon, VFlow } from 'bold-ui'
import { AlergiaSelectFieldModel } from 'components/form/field/select/AlergiaSelectField/AlergiaSelectField'
import React, { useState } from 'react'
import {
  AlergiasReacoesForm,
  AlergiasReacoesProps,
} from 'view/atendimentos/detail/soap/avaliacao/components/alergias-reacoes/AlergiasReacoesForm'

export interface CadastroAlergiasModalProps
  extends Pick<AlergiasReacoesProps, 'formValues' | 'dataAtendimento' | 'onSubmit'> {
  alergiasCidadao: AlergiaSelectFieldModel[]
}

export function CadastroAlergiasModal(props: CadastroAlergiasModalProps) {
  const { alergiasCidadao } = props
  const [showForm, setShowForm] = useState<boolean>(false)

  return (
    <VFlow>
      <Button
        kind='primary'
        onClick={() => {
          setShowForm(!showForm)
        }}
      >
        <HFlow>
          <Icon icon={showForm ? 'angleUp' : 'angleDown'} />
          {showForm ? 'Cancelar adição' : 'Adicionar alergia/reação adversa anterior'}
        </HFlow>
      </Button>
      {showForm && (
        <div style={{ marginLeft: '-1rem' }}>
          <AlergiasReacoesForm
            isModal
            alergiasCidadao={alergiasCidadao}
            initialValues={{ _id: null, isAvaliacao: false }}
            buttonTexts={{ cancel: 'Limpar Campos', submit: 'Adicionar' }}
            {...props}
          />
        </div>
      )}
    </VFlow>
  )
}
